import React, { useContext } from 'react';
import Route from 'react-router-dom/Route';
import Redirect from 'react-router-dom/Redirect';
import { AuthContext } from '../providers/AuthProvider';

function RouterOutlet(route) {
  const auth = useContext(AuthContext);
  const { isLoggedIn } = auth;
  const isProtected = typeof route.isProtected !== 'undefined' ? route.isProtected : true;

  const render = (props) => {
    const component = (
      <route.component
        {...props}
        routes={route.routes}
        config={{
          name: route.name,
          main: route.main,
        }}
      />
    );

    if (isProtected) {
      return (isLoggedIn
        ? component
        : <Redirect to={{ pathname: '/login' }} />);
    }

    return component;
  };

  const routeProps = {
    path: route.path,
    render,
  };
  if (route.exact) routeProps.exact = true;

  return <Route {...routeProps} />;
}

export default RouterOutlet;
